import neutral0 from './neutral/left-right_0001.png';
import left0 from './left/left-right_0006.png';
import left1 from './left/left-right_0009.png';
import left2 from './left/left-right_0012.png';
import left3 from './left/left-right_0014.png';
import left4 from './left/left-right_0025.png';
import left5 from './left/left-right_0027.png';
import left6 from './left/left-right_0030.png';
import left7 from './left/left-right_0034.png';
import right0 from './right/left-right_0133.png';
import right1 from './right/left-right_0134.png';
import right2 from './right/left-right_0135.png';
import right3 from './right/left-right_0136.png';
import right4 from './right/left-right_0138.png';
import right5 from './right/left-right_0140.png';
import right6 from './right/left-right_0142.png';
import right7 from './right/left-right_0144.png';
import up0 from './up/up_0130.png';
import up1 from './up/up_0129.png';
import up2 from './up/up_0128.png';
import up3 from './up/up_0127.png';
import up4 from './up/up_0126.png';
import up5 from './up/up_0124.png';
import up6 from './up/up_0122.png';
import up7 from './up/up_0120.png';
import down0 from './down/down_0115.png';
import down1 from './down/down_0114.png';
import down2 from './down/down_0113.png';
import down3 from './down/down_0112.png';
import down4 from './down/down_0111.png';
import down5 from './down/down_0110.png';
import down6 from './down/down_0109.png';

// Direction sequences run from mild to strong (screen/viewer coordinates).
export const avatarFrames = {
  neutral: neutral0,
  left: [left0, left1, left2, left3, left4, left5, left6, left7],
  right: [right0, right1, right2, right3, right4, right5, right6, right7],
  up: [up0, up1, up2, up3, up4, up5, up6, up7],
  down: [down0, down1, down2, down3, down4, down5, down6]
};
